export default async function getCroppedImg(imageSrc, pixelCrop) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        
        image.onload = () => {
            const canvas = document.createElement('canvas');
            // Use the actual crop dimensions to maintain quality
            canvas.width = pixelCrop.width;
            canvas.height = pixelCrop.height;
            const ctx = canvas.getContext('2d');
            
            // Enable high-quality image rendering
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            
            // Draw the cropped portion of the image
            ctx.drawImage(
                image,
                pixelCrop.x,
                pixelCrop.y,
                pixelCrop.width,
                pixelCrop.height,
                0,
                0,
                pixelCrop.width,
                pixelCrop.height
            );

            // Use PNG for lossless quality, or JPEG with maximum quality
            // PNG preserves quality better but is larger
            canvas.toBlob((blob) => {
                if (blob) {
                    resolve(URL.createObjectURL(blob));
                } else {
                    reject(new Error('Failed to generate blob'));
                }
            }, 'image/png', 1.0); // PNG with maximum quality (lossless)
        };
        
        image.onerror = () => {
            reject(new Error('Failed to load image'));
        };
        
        image.src = imageSrc;
    });
}

